import React from 'react';
import { createStyles } from "./styles";





var FilterSection = function FilterSection(_ref) {var _ref$sectionTitle = _ref.sectionTitle,sectionTitle = _ref$sectionTitle === void 0 ? '' : _ref$sectionTitle,children = _ref.children;
  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement("div", { className: classes.section },
    sectionTitle && /*#__PURE__*/React.createElement("h3", { className: classes.sectionTitle }, sectionTitle),
    children));


};

export default FilterSection;
//# sourceMappingURL=index.js.map